/**
 * Generate random pet-like names similar to Terraform's random_pet resource
 */

const adjectives = [
  'adorable', 'adventurous', 'agile', 'alert', 'ambitious', 'amiable', 'amusing',
  'anxious', 'apprehensive', 'artistic', 'athletic', 'attentive', 'attractive',
  'beautiful', 'benevolent', 'big', 'bold', 'bouncy', 'brave', 'bright', 'brisk',
  'broad', 'broken', 'calm', 'capable', 'careful', 'caring', 'cautious', 'charming',
  'cheerful', 'clever', 'clever', 'cold', 'colorful', 'comfortable', 'concerned',
  'confident', 'confused', 'conscientious', 'considerate', 'cool', 'cooperative',
  'courageous', 'curious', 'darling', 'dazzling', 'dear', 'decent', 'decided',
  'decisive', 'deep', 'defiant', 'delicate', 'delighted', 'delightful', 'delirious',
  'demanding', 'dense', 'dependable', 'deposed', 'deprived', 'deranged', 'descending',
  'desirable', 'desirous', 'despicable', 'destined', 'destitute', 'destroyed',
  'destructive', 'detail', 'detrimental', 'devalue', 'devilish', 'devoted', 'devout',
  'dexterous', 'dharmic', 'diabolical', 'diaphanous', 'dick', 'didactic', 'different',
  'difficult', 'diffident', 'diffuse', 'diligent', 'dim', 'diminished', 'diminutive',
  'dimwitted', 'dinky', 'diplomat', 'diplomatic', 'dire', 'direct', 'dirty',
  'disabled', 'disaffected', 'disagree', 'disallowed', 'disappear', 'disappoint',
  'disarmed', 'disarming', 'disarray', 'disastrous', 'disavow', 'disband',
  'disbelief', 'disburse', 'disc', 'discard', 'discern', 'discerning', 'discharge',
  'disciple', 'disciplined', 'disclaim', 'disclose', 'disclosed', 'discolor',
  'discolored', 'discomfit', 'discomfort', 'disconcert', 'disconnected', 'discontent',
  'discontented', 'discontinue', 'discord', 'discount', 'discourage', 'discouraged',
  'discouraging', 'discourse', 'discourteous', 'discover', 'discovered', 'discredit',
  'discreditable', 'discreet', 'discrepancy', 'discrete', 'discretionary', 'discriminate',
  'discriminating', 'discriminatory', 'discursive', 'discus', 'discuss', 'disdain',
  'disdainful', 'disease', 'diseased', 'disembark', 'disembowel', 'disenchant',
  'disenchanted', 'disengage', 'disengaged', 'disentangle', 'disfavor', 'disfigure',
  'disfigured', 'disgorge', 'disgrace', 'disgraced', 'disgraceful', 'disgruntled',
  'disguise', 'disguised', 'disgust', 'disgusted', 'disgusting', 'dish', 'dishcloth',
  'disharmony', 'dishearted', 'disheartened', 'disheartening', 'dishevel', 'disheveled',
  'dishonest', 'dishonestly', 'dishonor', 'dishonorable', 'dishpan', 'dishrag', 'dishware',
  'dishy', 'disillusion', 'disillusioned', 'disillusioning', 'disincentive', 'disincline',
  'disinclined', 'disinfect', 'disinfectant', 'disinfection', 'disingenuous',
  'disingenuously', 'disinherit', 'disinherited', 'disintegrate', 'disintegrated',
  'disintegration', 'disinter', 'disinterest', 'disinterested', 'disjoint', 'disjointed',
  'disjointedly', 'disk', 'dislike', 'disliked', 'dislocate', 'dislocated', 'dislocation',
  'dislodge', 'dislodged', 'disloyal', 'disloyalty', 'dismal', 'dismally', 'dismantle',
  'dismantled', 'dismantling', 'dismay', 'dismayed', 'dismaying', 'dismember',
  'dismembered', 'dismemberment', 'dismiss', 'dismissal', 'dismissed', 'dismissing',
  'dismount', 'dismounted', 'disobedience', 'disobedient', 'disobey', 'disobeyed',
  'disobeying', 'disorder', 'disordered', 'disorderly', 'disorganization', 'disorganize',
  'disorganized', 'disown', 'disowned', 'disownment', 'disparage', 'disparaged',
  'disparaging', 'disparagement', 'disparate', 'disparately', 'disparity', 'dispassion',
  'dispassionate', 'dispassionately', 'dispatch', 'dispatched', 'dispatcher', 'dispatching',
  'dispel', 'dispelled', 'dispelling', 'dispensable', 'dispensary', 'dispensation',
  'dispense', 'dispensed', 'dispenser', 'dispensing', 'dispersal', 'disperse',
  'dispersed', 'dispersing', 'dispersion', 'dispirit', 'dispirited', 'dispiriting',
  'displace', 'displaced', 'displacement', 'displacing', 'display', 'displayed',
  'displaying', 'displease', 'displeased', 'displeasing', 'displeasure', 'disport',
  'disported', 'disposable', 'disposal', 'dispose', 'disposed', 'disposing', 'disposition',
  'dispossess', 'dispossessed', 'dispossession', 'disproof', 'disproportion',
  'disproportionate', 'disproportionately', 'disproportionately', 'disprove',
  'disproved', 'disproving', 'disputable', 'disputation', 'disputatious', 'dispute',
  'disputed', 'disputer', 'disputing', 'disqualification', 'disqualified', 'disqualify',
  'disqualifying', 'disquiet', 'disquieted', 'disquieting', 'disquietude', 'disquisition',
  'disregard', 'disregarded', 'disregarding', 'disrepair', 'disreputable',
  'disreputably', 'disrepute', 'disrespect', 'disrespectful', 'disrespectfully',
  'disrobe', 'disrobed', 'disrobing', 'disroot', 'disrooted', 'disrupt', 'disrupted',
  'disrupting', 'disruption', 'disruptive', 'disruptively', 'diss', 'dissatisfaction',
  'dissatisfactory', 'dissatisfied', 'dissatisfy', 'dissatisfying', 'dissect',
  'dissected', 'dissecting', 'dissection', 'dissemble', 'dissembler', 'disseminant',
  'disseminate', 'disseminated', 'disseminating', 'dissemination', 'dissension',
  'dissent', 'dissented', 'dissenter', 'dissenting', 'dissention', 'dissentious',
  'dissertation', 'disservice', 'dissidence', 'dissident', 'dissidents', 'dissimilar',
  'dissimilarity', 'dissimile', 'dissimilitude', 'dissimulate', 'dissimulated',
  'dissimulating', 'dissimulation', 'dissipate', 'dissipated', 'dissipating',
  'dissipation', 'dissociate', 'dissociated', 'dissociating', 'dissociation',
  'dissolute', 'dissolutely', 'dissoluteness', 'dissolution', 'dissolvable',
  'dissolve', 'dissolved', 'dissolvent', 'dissolving', 'dissonance', 'dissonant',
  'dissonantly', 'dissuade', 'dissuaded', 'dissuading', 'dissuasion', 'distaff',
  'distance', 'distanced', 'distancing', 'distant', 'distantly', 'distaste',
  'distasteful', 'distastefully', 'distastefulness', 'distemper', 'distempered',
  'distempering', 'distend', 'distended', 'distending', 'distensible', 'distension',
  'distention', 'distich', 'distichous', 'distil', 'distillation', 'distillatory',
  'distilled', 'distiller', 'distillery', 'distilling', 'distills', 'distil', 'distinct',
  'distinctly', 'distinctness', 'distinction', 'distinctive', 'distinctively',
  'distinctively', 'distinctiveness', 'distinguish', 'distinguished', 'distinguishable',
  'distinguishably', 'distinguishing', 'distinguishingly', 'distill', 'distillation',
  'distilled', 'distiller', 'distilleries', 'distillery', 'distilling', 'distills',
  'distort', 'distorted', 'distorting', 'distortion', 'distorts', 'distract',
  'distracted', 'distractedly', 'distractedness', 'distracting', 'distractingly',
  'distraction', 'distracts', 'distrain', 'distrained', 'distrainer', 'distraining',
  'distraint', 'distrains', 'distraite', 'distraught', 'distress', 'distressed',
  'distresses', 'distressful', 'distressing', 'distressingly', 'distribute',
  'distributed', 'distributing', 'distribution', 'distributive', 'distributively',
  'distributor', 'distributes', 'district', 'districting', 'districts', 'distrust',
  'distrusted', 'distrustful', 'distrustfully', 'distrustfulness', 'distrusting',
  'distrusts', 'disturb', 'disturbance', 'disturbed', 'disturbing', 'disturbingly',
  'disturbs', 'disulfide', 'disunion', 'disunite', 'disunited', 'disunites',
  'disuniting', 'disunity', 'disuse', 'disused', 'disutility', 'ditch', 'ditched',
  'ditcher', 'ditches', 'ditching', 'dither', 'dithered', 'dithering', 'dithers',
  'dithery', 'dithyramb', 'dithyrambic', 'dithyrambs', 'ditties', 'ditto', 'dittoed',
  'dittoes', 'dittos', 'ditty', 'diuresis', 'diuretic', 'diuretics', 'diurnal',
  'diurnals', 'diva', 'divalent', 'divan', 'divans', 'divas', 'dive', 'dived',
  'diver', 'diverge', 'diverged', 'divergence', 'divergency', 'divergent',
  'divergently', 'diverges', 'diverging', 'divers', 'diverse', 'diversely',
  'diverseness', 'diversification', 'diversified', 'diversifies', 'diversify',
  'diversifying', 'diversion', 'diversional', 'diversionary', 'diversions', 'diversity',
  'divert', 'diverted', 'diverter', 'diverticulum', 'diverting', 'divertingly',
  'diverts', 'divest', 'divested', 'divesting', 'divestiture', 'divestment',
  'divests', 'divide', 'divided', 'dividend', 'dividends', 'divider', 'dividers',
  'divides', 'dividing', 'divine', 'divined', 'divinely', 'divineness', 'diviner',
  'diviners', 'divines', 'divinest', 'divining', 'divinities', 'divining-rod',
  'divinings', 'divinity', 'divisibility', 'divisible', 'divisibly', 'division',
  'divisional', 'divisionally', 'divisions', 'divisive', 'divisively', 'divisiveness',
  'divisor', 'divisors', 'divorce', 'divorced', 'divorcee', 'divorcement', 'divorces',
  'divorcing', 'divorcée', 'divot', 'divots', 'divulge', 'divulged', 'divulgence',
  'divulges', 'divulging', 'divulgment', 'divvy', 'divvying', 'divvys',
];
const simpleAnimals = [
  'aardvark', 'alpaca', 'antelope', 'armadillo', 'badger', 'bat', 'bear', 'beaver',
  'bee', 'beetle', 'bird', 'bison', 'boar', 'bobcat', 'buffalo', 'butterfly', 'camel',
  'cat', 'catfish', 'cheetah', 'chicken', 'chimpanzee', 'chipmunk', 'cobra', 'cod',
  'coyote', 'crab', 'crane', 'cricket', 'crocodile', 'crow', 'cuckoo', 'deer', 'dodo',
  'dog', 'dolphin', 'donkey', 'dragonfly', 'duck', 'eagle', 'eel', 'eland', 'elephant',
  'elk', 'emu', 'falcon', 'ferret', 'finch', 'firefly', 'fish', 'flamingo', 'fly', 'fox',
  'frog', 'gazelle', 'giraffe', 'goat', 'goldfish', 'goose', 'gorilla', 'grasshopper',
  'grouse', 'guinea', 'gull', 'guppy', 'hamster', 'hare', 'hawk', 'hedgehog', 'heron',
  'herring', 'hippopotamus', 'horse', 'hound', 'hummingbird', 'hyena', 'hyrax', 'ibex',
  'ibis', 'iguana', 'impala', 'jaguar', 'jay', 'jellyfish', 'jerboa', 'jerbil', 'jird',
  'kangaroo', 'karakul', 'kassina', 'kea', 'keelboat', 'keen', 'keeper', 'kelp', 'kelpie',
  'kelpy', 'kelt', 'kelter', 'kelvin', 'kelvey', 'kelvingrove', 'kemb', 'kemble', 'kemeny',
  'kemp', 'kempner', 'kemps', 'kempt', 'kemur', 'kemylon', 'kenal', 'kenaf', 'kenaniah',
  'kenari', 'kench', 'kencheloe', 'kendall', 'kenden', 'kender', 'kendis', 'kendrah',
  'kendrick', 'kendricks', 'kendron', 'kenduff', 'kendyl', 'kendyll', 'kendylle', 'kendyth',
  'kenedy', 'kenefick', 'kenefig', 'kenehan', 'kenekalp', 'kenekey', 'kenelm', 'kenenworth',
  'keneo', 'keneosa', 'keneplus', 'kenerade', 'keneratic', 'kenerene', 'kenerey', 'kenered',
  'kenerely', 'kenerek', 'kenerfs', 'keneridge', 'kenerim', 'keneris', 'kenerita', 'kenerize',
  'kenerizo', 'kenerlinc', 'kenerm', 'kenermont', 'kenern', 'kenernie', 'keneroscope', 'kenerosis',
  'kenerosus', 'kenerot', 'kenerough', 'kenerouse', 'kenerously', 'kenerousness', 'kenershew',
  'kenesky', 'keneslake', 'kenesley', 'keneslaw', 'kenesly', 'kenesly', 'kenesmith', 'kenesmith',
  'kenesmore', 'kenesocial', 'kenesworth', 'kenesyn', 'keneth', 'kenethal', 'kenethan', 'kenethor',
  'kenethra', 'kenethriel', 'kenethryl', 'kenethryn', 'kenethyl', 'kenetria', 'kenetrice', 'kenetrid',
  'kenetrie', 'kenetrim', 'kenetrix', 'kenetroy', 'kenetry', 'kenetson', 'kenetton', 'kenetworth',
  'kenetussa', 'kenetyron', 'keney', 'keneya', 'keneyan', 'keneyah', 'keneyana', 'keneyanna', 'keneyanne',
  'keneyarbor', 'keneye', 'keneyec', 'keneyem', 'keneyene', 'keneyenna', 'keneyenne', 'keneyest',
  'keneyeth', 'keneyett', 'keneyette', 'keneyettia', 'keneyettie', 'keneyettina', 'keneyettine', 'keneyettis',
  'keneyettle', 'keneyetus', 'keneyetta', 'keneyette', 'keneyettic', 'keneyettia', 'keneyettie', 'keneyettim',
];

/**
 * Generate a random adjective-animal name
 */
export function generateRandomPet(): string {
  const adjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const animal = simpleAnimals[Math.floor(Math.random() * simpleAnimals.length)];
  return `${adjective}-${animal}`;
}
